<template>
  <ion-page>
    <master-layout pageTitle="لیست قطعات">
      <div class="search-area" id="pageTop">
        <div class="search-input-area">
          <div class="fancy-title-wrapper search-input-area" style="padding-bottom: 10px;">
            <div class="fancy-title light">
              <h3 class="center text-white">اطلاعات فنی قطعات خودرو</h3>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <ion-grid id="parts-container">
        <ion-row>
          <ion-col size="6" v-for="item in parts" :key="item._id">
            <router-link :to="item.children?(currentUrl+item._id+'-'):'/cars/showPart/'+carTypeId+'/'+item._id">
              <div class="brand-model-item">
                <div class="thumbnail">
                  <img :src="(item.pic_url?item.pic_url:'https://carencar.com/desktop/img/logo.png')"/>
                </div>
                <div class="title">
                  <h4>{{ item.title }}</h4>
                </div>
              </div>
            </router-link>
          </ion-col>
        </ion-row>
      </ion-grid>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonGrid, IonRow, IonCol, IonPage} from '@ionic/vue'
import {mapActions} from "vuex";

export default {
  name: "parts",
  data: function ()
  {
    return {
      parts: [],
      fullParts:null,
      currentUrl:'',
      navigatedItems:[],
      carTypeId:'',
    }
  },
  mounted()
  {
    this.carTypeId = this.$route.params.typeId;
    this.currentUrl = this.$route.fullPath;
    if (!this.currentUrl.endsWith('/') && !this.currentUrl.endsWith('-'))
      this.currentUrl+='/';

    this.setNavigatedItems(this.$route.fullPath);

    this.getPartsStructure().then((parts)=>{
      this.fullParts = parts;
      this.setParts();
    })
  },
  methods: {
    initItems(url)
    {
      const elmnt = document.getElementById("pageTop");
      elmnt.scrollIntoView();

      this.currentUrl = url;
      if (!this.currentUrl.endsWith('/') && !this.currentUrl.endsWith('-'))
        this.currentUrl+='/';

      this.setNavigatedItems(url);

      this.setParts();
    },
    setNavigatedItems(url){
      const params = url.split('/');
      const partId = params.length===5?params[4]:null
      if (partId)
        this.navigatedItems = partId.slice(0,(partId.length-1)).split('-');
      else
        this.navigatedItems = [];
    },
    ...mapActions("car", {
      getPartsStructure: 'getPartsStructure',
    }),
    setParts()
    {
      console.log('set lunched')
      if (this.navigatedItems && this.navigatedItems.length)
      {
        console.log('nav check')
        let filteredParts = JSON.parse(JSON.stringify(this.fullParts));
        for (let j=0;j<this.navigatedItems.length;j++)
        {
          const n = this.navigatedItems[j];
          let found = false;
          for (let i=0;i<filteredParts.length;i++)
          {
            const p = filteredParts[i];
            if (p._id===n)
            {
              console.log('children',p.children)
              found = true;
              filteredParts = JSON.parse(JSON.stringify(p.children));
            }
          }
          if (!found)
          {
            console.log('part not found');
            break;
          }
        }
        this.parts = filteredParts;
      }
      else
      {
        this.parts = JSON.parse(JSON.stringify(this.fullParts));
      }
      console.log(this.parts.length);
    }
  },
  components: {
    IonGrid, IonRow, IonCol, IonPage
  },
  props:{
    default:null
  },
  watch: {
    '$route.path': {
      handler(newUrl)
      {
        this.initItems(newUrl)
      }
    }
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}
.thumbnail{
  text-align: center;
}
.thumbnail img{
  width: 125px;
  height: 125px;
  border-radius: 5px;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}
</style>